/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles, createMuiTheme, ThemeProvider  } from '@material-ui/core/styles'
import { Paper, Typography, Divider, TextField, Button } from '@material-ui/core'
import CircularProgress from '@material-ui/core/CircularProgress';

import Actions from '../../../fluid/Actions/ActionFactory'
import FlexForm from '../../FlexForm/FlexForm'

const clone = require('rfdc')()

const styles = theme => ({
    text_field : {
        width : '40%',
    }
})

const blue_theme = createMuiTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        secondary: {
          main: '#ff9100',
        },
      },
})

class AdaptorInputs extends Component {
    state = {
        fields: [],
        edit : false,
        fields_ready : false,
        error_message : "",
        loading : false,
        submit_load : false,
        validation : false
    }

    componentDidMount () {
        const headingHeight = this.heading.current.clientHeight
        const footerHeight = this.footer.current.clientHeight
        const contentHeight = this.props.maxHeight - headingHeight - footerHeight

        this.setState({...this.state, content_height : contentHeight, heading_height : headingHeight}, () => {
            Actions('http_request', {
                url : '/sainapse/information_channel/' + this.props.ic_name + '/information_unit/' + this.props.iu_name + '/adapter_input_parameters_schema',
                method : 'get',
                data : {}
            }).then(res => {
                this.setState({
                    ...this.state,
                    fields : res.data.result,
                    fields_ready : true
                }, () => console.log('Set Adaptor Inputs State: ', this.state))
            }).catch(err => {
                this.setState({
                    ...this.state,
                    fields_ready : false,
                    error_message: err.response.data.message
                })
            })
        })
    }

    componentDidUpdate (prevProps, prevState) {
        console.log('Did Update')
        if (prevProps.maxHeight === null && this.props.maxHeight !== null) {
            const headingHeight = this.heading.current.clientHeight
            const footerHeight = this.footer.current.clientHeight
            const contentHeight = this.props.maxHeight - headingHeight - footerHeight
            console.log('Max Height IU: ', this.props.maxHeight)
            console.log('Head Height :', headingHeight)
            console.log('Content Height IU :', contentHeight)
            this.setState({...this.state, content_height : contentHeight, heading_height : headingHeight})
        }
    }

    heading = React.createRef()
    footer = React.createRef()

    handleChange = (value, index) => {
        let new_state = clone(this.state)
        new_state.fields[index].value = value

        this.setState({...new_state}, () => console.log('Set Adaptor Inputs State :', this.state))
    }
    
    setAdaptorInputs = () => {
        this.setState({
            ...this.state,
            error_message : null,
            submit_load : true
        }, () => {
            Actions('http_request', {
                url : '/sainapse/information_channel/' + this.props.ic_name + '/information_unit/' + this.props.iu_name + '/adapter_input_parameters',
                method : 'post',
                data: this.state.fields
            }).then(res => {
                this.setState({...this.state, error_message : null, submit_load : false}, () => this.props.handleNext())
            }).catch(err => {
                let error = err.response.data
                this.setState({...this.state, error_message : error.message, loading : false, fields_ready : true, submit_load : false})
            })
        })
    }

    updateForm = (form) => {
        this.setState({...this.state, fields: form}, () => console.log('Adaptor State : ', this.state))
    }

    renderForm = () => {
        if (this.state.loading === false) {
            if (this.state.fields_ready) {
                if (this.state.fields.length > 0 ) {
                    return (
                        <Fragment>
                            {/* <Typography style = {{color : '#f44336', marginBottom : '8px'}} variant = 'caption'>{this.state.error_message}</Typography> */}
                            <FlexForm 
                                config = {this.state.fields} 
                                fields_in_scope = {[]} 
                                update_parent = {(form) => this.updateForm(form)}
                                validate = {true}
                                validation_status = {(status) => this.setState({...this.state, validation : status})}
                                submit = {(form) =>  this.setAccessDetails(form)} 
                                grid_element_width = "32%"
                            />
                        </Fragment>
                    )
                } else {
                    return (
                        <div style = {{width : '100%', height : '100%', display: 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                            <Typography variant = 'body2'>This IU does not need any Adaptor Inputs.</Typography>
                        </div>
                    )
                }
            }
        } else {
            return (
                <div style = {{width : '100%', height : '100%', display: 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                    <CircularProgress color = 'primary'/>
                </div>
            )
        }
    }

    render() {
        const { classes } = this.props
        return (
            <Paper elevation = {0} square style = {{width : '100%', height : '100%'}}>
                <div style = {{width : '100%', height : '100%'}}>
                    <div 
                        ref = {this.heading} 
                        style = {{
                            display : 'flex', 
                            flexDirection : 'row', 
                            alignItems : 'center',
                            alignContent : 'flex-end',
                            backgroundColor : '#F0F0F0',
                            borderBottom : '1px solid rgba(0,0,0,0.12)',
                            padding : '8px'
                        }}>
                        <Typography variant='h6' style = {{flexGrow : 1}}>Set Adaptor Inputs</Typography>
                        <Typography style = {{color : '#F50157'}} variant = 'caption'>{this.state.error_message}</Typography>
                    </div>
                    <div
                        style = {{
                            width : '100%',
                            height: this.state.content_height,
                            overflow: 'scroll',
                            padding : '8px'
                        }}>
                        <ThemeProvider theme = {blue_theme}>
                            {this.renderForm()}
                        </ThemeProvider>
                    </div>
                    <div ref = {this.footer} 
                        style = {{
                            display : 'flex', 
                            flexDirection : 'row-reverse',
                            backgroundColor : '#F0F0F0',
                            padding : '8px',
                            borderTop : '1px solid rgba(0,0,0,0.12)',
                        }}>
                        <ThemeProvider theme = {blue_theme}>
                            <Button
                                variant = 'contained'
                                color = 'primary'
                                size = 'small'
                                onClick = {this.setAdaptorInputs}
                                startIcon = {this.state.submit_load ? <CircularProgress style = {{color : '#FFFFFF'}} size = {20}/> : null}
                            >
                                {this.state.fields.length > 0 ? 'Submit' : 'Next'}
                            </Button>
                        </ThemeProvider>
                    </div>
                </div> 
            </Paper>
        );
    }
}

export default withStyles(styles)(AdaptorInputs);